import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import MarvelLogo from 'marketing-website/components/commons/MarvelLogo';

import globalStyles from './style/global.module.css';

export default function HeaderLogo({ toggleNav, isNavOpen, isLight }) {
  const handleClick = () => {
    if (isNavOpen) {
      toggleNav();
    }
  };

  const MarvelLogoProps = {
    size: 'm',
    color: isLight ? 'white' : 'marvel',
  };

  return (
    <div className={globalStyles.logo} aria-label="Marvel App">
      <Link to="/" className="inline-block" onClick={handleClick}>
        <MarvelLogo {...MarvelLogoProps} />
      </Link>
    </div>
  );
}

HeaderLogo.propTypes = {
  isNavOpen: PropTypes.bool.isRequired,
  isLight: PropTypes.bool,
  toggleNav: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderLogo/index.js